"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var TYPES = {
  Array: 'Array',
  Uint8Array: 'Uint8Array',
  PAT: 'PAT',
  PMT: 'PMT',
  NALU: 'NALU',
  Packet: 'Packet',
  MediaPacket: 'MediaPacket',
  PESPacket: 'PESPacket',
  MediaInitializationSegment: 'MediaInitializationSegment',
  MediaSegment: 'MediaSegment',
  MediaPlaylist: 'MediaPlaylist',
  MasterPlaylist: 'MasterPlaylist',
  VariantStream: 'VariantStream',
  Rendition: 'Rendition'
};
var _default = TYPES;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@krad/plainview/node_modules/@krad/slugline/distribution/types.js
// module id = 89
// module chunks = 0